import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestSection() {
  const latest = getLatestComics().slice(0, 10);

  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">保持追更，不错过任何精彩</p>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部更新
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
        {latest.map((comic) => (
          <div key={comic.id} data-product-shop>
            <ComicCard comic={comic} />
          </div>
        ))}
      </div>
    </section>
  );
}